import type { WorksheetDesignTemplate } from '@mathflat/domain/Worksheet'
import { makeAutoObservable } from 'mobx'

import { worksheetController } from '@/controller/worksheet.controller'

export type WorksheetDesignTemplateT = WorksheetDesignTemplate

class DesignTemplateService {
  worksheetDesignTemplateList: WorksheetDesignTemplate[] = []

  constructor() {
    makeAutoObservable(this)
  }

  async fetchAllDesignTemplateList() {
    const [worksheetDesignTemplate] = await Promise.all([worksheetController.fetchDesignTemplate()])

    this.worksheetDesignTemplateList = worksheetDesignTemplate.sort((x, y) => x.index - y.index)
  }
}

const designTemplateService = new DesignTemplateService()
export default designTemplateService
